import {extend} from 'quasar'
import {handleError} from '../../plugins/errors'
import qs from 'qs'
import {normalizeApiData, normalizeRow, oDataFilter, oDataHelper, oDataSort} from '../../utils/oData'

const globalConfig = {}
const defaultActions = {
  /**
   ********** Provides Defaults ***********
   */
  transformFilters ({ commit, state, getters }, config) {
    /* if (config && config.params && config.params.filter) {
      let newConfig = { ...config }
      const filter = newConfig.params.filter
      if (filter) {
        const newFilter = Object.keys(filter).reduce((filterObj, filterKey) => {
          if (filter[filterKey] === undefined || filter[filterKey] === '' || filter[filterKey] === null) {
            return filterObj
          }
          const nestedArray = filterKey.split('.')
          const newFilterKey = nestedArray.reduce((txt, nestedKey, counter) => {
            const camelCol = camelCase(nestedKey)
            const isRelation = state.columns.some(col => {
              // // // // console.log('>>> col', col.field, camelCol, !!col.relation)
              return col.field === camelCol && col.relation
            })
            // // // // console.log('--- is relation? --- ', isRelation)
            const appendDot = counter < nestedArray.length - 1 ? '.' : ''
            txt = isRelation ? `${txt}${camelCase(nestedKey)}${appendDot}` : `${txt}${camelCase(nestedKey)}${appendDot}`
            return txt
          }, '')
          filterObj[newFilterKey] = filter[filterKey]
          return filterObj
        }, {})
        newConfig.params.filter = Object.assign({}, newFilter)
        // -- pagination
        if (state.settings && state.settings.pagination) {
          const { page, rowsPerPage } = state.settings.pagination
          if (config.params.limit !== undefined) {
            newConfig.params.limit = config.params.limit
          } else {
            newConfig.params.limit = rowsPerPage || null
          }
          if (config.params.page !== undefined) {
            newConfig.params.page = config.params.page
          } else {
            newConfig.params.page = page || 1
          }
        }
        // // // console.log('----- NEW CONFIG --------', newConfig)
        return newConfig
      }
    } */
    return config
  },

  async apiDelete ({ commit, dispatch, state, getters }, { id, client, config = {}, parentId = null }) {
    const stateParams = {
      params: state.params
    }
    const configCombined = extend(true, {}, globalConfig, stateParams, config)
    let endpoint = getters.apiEndpoint(parentId)
    if (endpoint.includes('api/company')) {
      endpoint = '/api/delete/company/person'
    }
    try {
      const newConfig = await dispatch('transformFilters', configCombined)
      const { data } = await client.delete(`${endpoint}/${id}`, newConfig)
      commit('API_DESTROY', id)
      return data
    } catch (e) {
      return e
    }
  },
  async apiForceDelete ({ commit, dispatch, state, getters, rootGetters }, { id, client, config = {}, parentId = null, resource = null }) {
    // console.log('id', id, 'client', client, 'parentId', parentId)
    const stateParams = {
      params: state.params
    }
    const configCombined = extend(true, {}, globalConfig, stateParams, config)
    try {
      const newConfig = await dispatch('transformFilters', configCombined)
      let aspnetuserId = false
      if (getters.namespace === 'person' || resource === 'person') {
        // Remove user from person
        let config = {
          params: {
            $filter: `id eq ${id}`
          }
        }
        const personEnpoint = rootGetters[`person/apiEndpoint`]()
        const odataPersonEnpoint = personEnpoint.replace('/api/', '/api/odata/')
        const { data } = await client.get(`${odataPersonEnpoint}/paginate`, config)
        if (data && data.data && data.data.length && data.data[0].aspnetuserId) {
          aspnetuserId = data.data[0].aspnetuserId
        }
      }
      await dispatch('clearRelations', { id, client, parentId, resource })
      // return await dispatch('fetchAll', { client, parentId, config, fetchRelated, returnAll })
      // console.log('force delete', id)
      let data = {}
      if (resource) {
        let { data } = await client.delete(`/api/${resource}/${id}?harddelete=true`, {})
      } else {
        let { data } = await client.delete(`${getters.apiEndpoint(parentId)}/${id}?harddelete=true`, newConfig)
      }
      commit('API_DESTROY', id)
      if (aspnetuserId) {
        // delete aspnet user
        const userEnpoint = rootGetters[`aspnetuser/apiEndpoint`]()
        const userData = await client.delete(`${userEnpoint}/${aspnetuserId}?harddelete=true`, {})
        // console.log('delete user data', userData.data)
      }
      return data
    } catch (e) {
      return e
    }
  },
  async clearRelations ({ getters, rootGetters, dispatch }, { id, client, parentId = null, resource = null }) {
    let personData = []
    if (getters.namespace === 'person' || resource === 'person') {
      console.log('======= clearRelations person', id)
      let config = {
        params: {
          $filter: `billingPersonId eq ${id} or businessDevPersonId eq ${id} or counselPersonId eq ${id} or hrPersonId eq ${id} or marketingPersonId eq ${id} or primaryPersonId eq ${id} or safetyPersonId eq ${id} or chasePersonId eq ${id} or estimatorPersonId eq ${id} or estimator2PersonId eq ${id} or projectManagerPersonId eq ${id} or projectManager2PersonId eq ${id} or laborPersonId eq ${id}`
        }
      }
      const companyEnpoint = rootGetters[`company/apiEndpoint`]()
      const odataCompanyEnpoint = companyEnpoint.replace('/api/', '/api/odata/')
      const { data } = await client.get(`${odataCompanyEnpoint}/paginate`, config)
      // console.log('odataCompanyEnpoint', odataCompanyEnpoint, 'data', data)
      if (data && data.data && data.data.length) {
        let clearPerson = {}
        for (let company of data.data) {
          if (company.billingPersonId === id) {
            clearPerson.billingPersonId = null
          }
          if (company.businessDevPersonId === id) {
            clearPerson.businessDevPersonId = null
          }
          if (company.counselPersonId === id) {
            clearPerson.counselPersonId = null
          }
          if (company.hrPersonId === id) {
            clearPerson.hrPersonId = null
          }
          if (company.marketingPersonId === id) {
            clearPerson.marketingPersonId = null
          }
          if (company.primaryPersonId === id) {
            clearPerson.primaryPersonId = null
          }
          if (company.safetyPersonId === id) {
            clearPerson.safetyPersonId = null
          }
          if (company.chasePersonId === id) {
            clearPerson.chasePersonId = null
          }
          if (company.estimatorPersonId === id) {
            clearPerson.estimatorPersonId = null
          }
          if (company.estimator2PersonId === id) {
            clearPerson.estimator2PersonId = null
          }
          if (company.projectManagerPersonId === id) {
            clearPerson.projectManagerPersonId = null
          }
          if (company.projectManager2PersonId === id) {
            clearPerson.projectManager2PersonId = null
          }
          if (company.laborPersonId === id) {
            clearPerson.laborPersonId = null
          }
          // console.log('clearPerson', clearPerson)
          const { data } = await client.put(`${companyEnpoint}/${company.id}`, clearPerson)
          // console.log('after clearPerson from Company', data)
        }
      }
    } else if (getters.namespace === 'company' || resource === 'company') {
      // Remove persons from company
      // console.log('======= clearRelations company', id)
      let config = {
        params: {
          $filter: `companyId eq ${id}`
        }
      }
      const personEnpoint = rootGetters[`person/apiEndpoint`]()
      const odataPersonEnpoint = personEnpoint.replace('/api/', '/api/odata/')
      const { data } = await client.get(`${odataPersonEnpoint}/paginate`, config)
      if (data && data.data && data.data.length) {
        personData = data.data
        // console.log('personData', personData)
        for (let person of personData) {
          // console.log('person/apiForceDelete', person.id, 'person')
          const { data } = await client.put(`${personEnpoint}/${person.id}`, {companyId: null})
          // console.log('updated person', data)
          // await dispatch('apiForceDelete', { id: person.id, client, config: {}, parentId, resource: 'person' })
        }
      }
    }
    for (let column of getters.columns) {
      let linkTable = false
      let { field, relation } = column
      let foreignId = field
      let relationData = []
      let syncUrl = `${getters.apiEndpoint(parentId)}/${id}/sync`
      if (column && relation) {
        // console.log('relation', relation, 'column', column)
        if (relation.linkTable || relation.namespace === 'comment') {
          // if (relation.type === 'one') {
          // one to many
          // } else if (relation && relation.linkTable) {
          // many to many
          let model = relation.namespace
          if (relation.linkTableModel) {
            model = relation.linkTableModel
            linkTable = relation.linkTableModel
          } else if (column && column.field) {
            model = column.field
            linkTable = column.field
          }
          // console.log('model', model)
          const relationColumns = rootGetters[`${model}/columns`]
          if (relationColumns) {
            // console.log('relationColumns', relationColumns)
            const linkTableColumn = relationColumns.filter(col => col.relation && col.relation.namespace === relation.namespace)
            if (linkTableColumn && linkTableColumn[0] && linkTableColumn[0].relation && linkTableColumn[0].relation.fk) {
              foreignId = linkTableColumn[0].relation.fk
            }
            // console.log('linkTableColumn', linkTableColumn)
            try {
              if (linkTable) {
                syncUrl = `${syncUrl}?linkTable=${linkTable}&forceDelete=true`
              }
              const formData = {
                // [field]: relationData
                [foreignId]: relationData
              }
              // console.log('syncUrl', syncUrl)
              // console.log('formData', formData)
              await client.post(syncUrl, formData)
            } catch (e) {
              return e
            }
          }
        }
      }
    }
    if (personData && personData.length) {
      // console.log('Start apiForceDelete loop on personData')
      for (let person of personData) {
        await dispatch('apiForceDelete', {id: person.id, client, config: {}, parentId, resource: 'person'})
      }
    }
  },
  /*
  Bulk delete: soft delete by list of ids
  */
  async apiPurge ({ commit, dispatch, state, getters }, { id = [], field, value, client, config = {}, parentId = null }) {
    const configCombined = { ...globalConfig, ...{ params: state.params }, ...config }
    try {
      const newConfig = await dispatch('transformFilters', configCombined)
      let endpoint = getters.apiEndpoint(parentId)
      if (endpoint.includes('api/company')) {
        endpoint = '/api/company/bulk'
      }
      const { data } = await client.post(`${endpoint}/purge`, { id }, newConfig)
      // const pagination = state.settings.pagination
      // commit('SET_SETTING', {
      //   field: 'selected',
      //   value: []
      // })
      // commit('SET_PAGINATION', {
      //   sortBy: pagination.sortBy ? pagination.sortBy : null,
      //   descending: !!pagination.descending,
      //   page: data.page || 1,
      //   rowsPerPage: pagination.rowsPerPage || 25,
      //   rowsNumber: data.total || 25
      // })
      if (data && data.data) {
        commit('FETCH_ALL', data.data)
        return data.total
      }
    } catch (e) {
      return e
    }
  },
  /*
  restore trashed items by list of ids
  */
  async apiRestore ({ commit, dispatch, state, getters }, { id = [], field, value, client, config = {}, parentId = null }) {
    const configCombined = extend(true, globalConfig, { params: state.params }, config, { params: { trashed: 1 } })
    let endpoint = getters.apiEndpoint(parentId)
    if (endpoint.includes('api/company')) {
      endpoint = '/api/company/bulk'
    }
    try {
      const newConfig = await dispatch('transformFilters', configCombined)
      const { data } = await client.post(`${endpoint}/restore`, { id }, newConfig)
      return data
    } catch (e) {
      return e
    }
  },
  async apiBulkUpdate ({ commit, dispatch, state, getters }, { type = null, fk = null, relation = false, id = [], field, value, client, config = {}, parentId = null }) {
    const configCombined = { ...globalConfig, ...{ params: state.params }, ...config }
    try {
      const patchData = {
        id: id,
        relation: relation,
        fk: fk,
        type: type,
        field: field,
        value: value
      }
      const newConfig = await dispatch('transformFilters', configCombined)
      const { data } = await client.post(`${getters.apiEndpoint(parentId)}/bulk-updates`, patchData, newConfig)
      if (data && data.data) {
        commit('FETCH_ALL', data.data)
        return data.total
      }
    } catch (e) {
      return e
    }
  },
  // async apiUpdate({ commit, dispatch, state, getters }, { id, model, client, config = {}, fetchRelated = true, parentId = null, returnAll = false }) {
  async apiInsert ({ commit, dispatch, state, getters }, { model, client, config = {}, fetchRelated = true, parentId = null, noFilters = false }) {
    const stateParams = {
      params: state.params
    }
    const stateFilters = {
      params: {
        filter: getters.filterColumns
      }
    }
    const configCombined = extend(true, {}, globalConfig, stateParams, stateFilters, config)
    try {
      const newConfig = await dispatch('transformFilters', noFilters ? config : configCombined)
      const { data } = await client.post(`${getters.apiEndpoint(parentId)}`, model, newConfig)
      commit('API_INSERT', data)
      // // // console.log('>> apiInsert')
      // // // console.log(data)
      return data
    } catch (e) {
      return e
    }
  },
  async search ({ commit, dispatch, state, getters }, { client, config = {}, parentId = null }) {
    let url = getters.apiEndpoint(parentId)
    url = url.replace('/api/', '/api/odata/') + '/paginate'
    //  http://localhost:5000/api/odata/person/paginate
    // removalDate eq null AND guestData ne true AND approved eq true
    console.log('config', config)
    let odataConfig = config
    odataConfig.$filter = 'removalDate eq null AND guestData ne true'
    let { data } = await client.get(url, config)
    if (data && data.data) {
      const transformedData = data.data ? normalizeApiData(data, getters.columns, state.fakeColumns) : data.data
      delete data.data
      data.data = transformedData
      console.log('transformedData', transformedData)
      return data
    }
    // if (data && data.search_ids) {
    //   // console.log('data.search_ids', data.search_ids)
    //   // console.log('Pre Sort', data)
    //   data = mapOrder(data.data, data.search_ids, 'id')
    //   // console.log('Sorted Array', mapped)
    //   // we want: 3788,103,2780,645,3847,2376,3569,683,550,1095
    //   return data
    // }
    // if (data) {
    //   return data
    // }
  },
  async fetchOne ({ commit, dispatch, state, getters }, { id, client, config = {}, parentId = null, noFilters = false, queue = true }) {
    const stateParams = {
      params: state.params
    }
    let configCombined = extend(true, {}, globalConfig, stateParams, config)
    if (noFilters && configCombined && configCombined.params && configCombined.params.filter) {
      delete configCombined.params.filter
    }
    if (noFilters && configCombined && configCombined.params && configCombined.params.limit) {
      delete configCombined.params.limit
    }
    if (noFilters && configCombined && configCombined.params && configCombined.params.sort) {
      delete configCombined.params.sort
    }
    if (noFilters && config) {
      configCombined = extend(true, {}, configCombined, config)
    }
    const newConfig = await dispatch('transformFilters', configCombined)

    // --------------------- ODATA ---------------------
    // console.log('state.params', state.params)
    // console.log('newConfig.params', newConfig.params)
    if (newConfig && newConfig.params && newConfig.params.include) {
      if (newConfig.params.odataInclude) {
        newConfig.params.$expand = newConfig.params.odataInclude
      } else {
        newConfig.params.$expand = oDataHelper(newConfig.params.include)
      }
      delete newConfig.params.include
    }
    if (newConfig && newConfig.params && newConfig.params.filter) {
      const module = state.namespace
      const oDataFilters = oDataFilter(newConfig.params.filter, module, state.fakeColumns)
      // // console.log('oDataFilters', oDataFilters)
      if (oDataFilters) {
        newConfig.params.$filter = `id eq ${id} and ` + oDataFilters
        // Object.assign(newConfig.params['$filter'], oDataFilters)
        // Object.assign(newConfig.params.$filter, oDataFilters)
      } else {
        newConfig.params.$filter = `id eq ${id}`
      }
      delete newConfig.params.filter
    } else {
      newConfig.params.$filter = `id eq ${id}`
    }
    // !--------------------- ODATA ---------------------

    /* Queue -- Method to reduce duplicate requests */
    // const url = `${getters.apiEndpoint(parentId)}/${id}`
    let url = `${getters.apiEndpoint(parentId)}` // ODATA
    url = url.replace('/api/', '/api/odata/') // ODATA
    url = `${url}/paginate` // ODATA

    const query = qs.stringify(newConfig)
    const queueExists = await dispatch('queue/find', { url, query }, { root: true })
    if (queueExists && queue) {
      const record = state.records.find(r => r.id === id)
      // console.log('queue record', record, 'queueExists', queueExists)
      if (record) {
        return record
      }
    }
    const queueId = await dispatch('queue/add', { url, query }, { root: true })
    // console.log('queueId', queueId)
    try {
      const { data } = await client.get(url, newConfig)
      const transformedData = normalizeRow(data.data[0], getters.columns, state.fakeColumns)
      commit('API_INSERT', transformedData)
      // await dispatch('queue/remove', queueId, { root: true })
      // console.log('transformedData', transformedData)
      return transformedData
    } catch (e) {
      await dispatch('queue/remove', queueId, { root: true })
      handleError(e, this)
      return null
    }
  },
  async groupBy ({ commit, dispatch, state, getters }, { client, parentId = null, group = null }) {
    const config = {
      params: {
        group,
        page: 1,
        limit: null,
        include: state.params.include,
        filter: {}
      }
    }
    let newConfig = await dispatch('transformFilters', config)
    // // // console.log(newConfig)
    const { data } = await client.get(`${getters.apiEndpoint(parentId)}`, newConfig)
    if (data) {
      commit('FETCH_ALL', data.data)
    }
  },
  // TODO: This is causing a maximum stack size issue
  async paginate ({ commit, dispatch, state, getters }, { client, pagination, search = null, parentId = null, trashed = null, noFilters = false, noTransform = false, config = {} }) {
    const { sortBy, descending, page, rowsPerPage } = pagination
    const filterColumns = getters.filterColumns
    const filtersToApply = Object.keys(getters.filterColumns)
      .filter(key => filterColumns[key] !== null)
      .reduce((obj, key) => {
        obj[key] = filterColumns[key]
        return obj
      }, {})
    const sortSign = descending ? '-' : ''
    const sortByOdata = oDataSort(sortBy, state.namespace, state.fakeColumns)
    let sort = null
    if (!search) {
      if (state && state.defaultSort) {
        sort = state.defaultSort
      }
      if (sortByOdata) {
        sort = `${sortSign}${sortByOdata}`
      }
    }
    const defaultConfig = {
      params: {
        sort,
        trashed,
        page,
        search,
        limit: rowsPerPage,
        include: state.params.include,
        filter: noFilters ? {} : filtersToApply
      }
    }
    let newConfig = extend(true, {}, defaultConfig, config)
    // console.log('state.params', state.params)
    // console.log('newConfig.params', newConfig.params)
    if (newConfig && newConfig.params && newConfig.params.include) {
      if (state.params.odataInclude) {
        newConfig.params.$expand = state.params.odataInclude
      } else {
        newConfig.params.$expand = oDataHelper(newConfig.params.include)
      }
      delete newConfig.params.include
    }
    if (newConfig && newConfig.params && newConfig.params.filter) {
      const module = state.namespace
      const oDataFilters = oDataFilter(newConfig.params.filter, module, state.fakeColumns)
      if (oDataFilters) {
        newConfig.params.$filter = oDataFilters
      }
      delete newConfig.params.filter
    }
    if (trashed) {
      newConfig.params.$filter = newConfig.params.$filter ? newConfig.params.$filter + ' AND removalDate ne null' : 'removalDate ne null'
    } else {
      newConfig.params.$filter = newConfig.params.$filter ? newConfig.params.$filter + ' AND removalDate eq null' : 'removalDate eq null'
    }
    if (state && state.namespace && (state.namespace === 'company' || state.namespace === 'person') && state.guestData) {
      if (state.guestData === 'only') {
        newConfig.params.$filter = newConfig.params.$filter ? newConfig.params.$filter + ` AND guestData eq true` : `guestData eq true`
      } else if (state.guestData === 'without' || state.guestData === null) {
        newConfig.params.$filter = newConfig.params.$filter ? newConfig.params.$filter + ` AND guestData ne true` : `guestData ne true`
      }
    }
    if (state && state.namespace && (state.namespace === 'company' || state.namespace === 'person' || state.namespace === 'address') && state.unapprovedData) {
      if (state.unapprovedData === 'only') {
        newConfig.params.$filter = newConfig.params.$filter ? newConfig.params.$filter + ` AND approved ne true` : `approved ne true`
      } else if (state.unapprovedData === 'without' || state.unapprovedData === null) {
        newConfig.params.$filter = newConfig.params.$filter ? newConfig.params.$filter + ` AND approved eq true` : `approved eq true`
      }
    }
    let url = getters.apiEndpoint(parentId)
    url = url.replace('/api/', '/api/odata/')
    url = `${url}/paginate`
    let ExcelUrl = url.replace('paginate', 'excel')
    let ExcelPrettyUrl = url.replace('paginate', 'excel')
    let urlConcat = '?'
    if (state.excelExport && (state.excelExport.include || state.excelExport.select)) {
      ExcelPrettyUrl = url.replace('paginate', 'prettyexcel')
    }
    if (state.excelExport && state.excelExport.include) {
      ExcelPrettyUrl += `?$expand=${state.excelExport.include}`
      urlConcat = '&'
    } else if (newConfig && newConfig.params.$expand) {
      ExcelPrettyUrl += `?$expand=${newConfig.params.$expand}`
      urlConcat = '&'
    }
    if (newConfig && newConfig.params.$expand) {
      ExcelUrl += `?$expand=${newConfig.params.$expand}`
      urlConcat = '&'
    }
    if (state.excelExport && state.excelExport.select) {
      ExcelPrettyUrl += urlConcat + `$select=${state.excelExport.select}`
    }
    if (newConfig && newConfig.params.$filter) {
      ExcelUrl += urlConcat + `$filter=${newConfig.params.$filter}`
      ExcelPrettyUrl += urlConcat + `$filter=${newConfig.params.$filter}`
    }
    ExcelUrl = decodeURIComponent(ExcelUrl)
      .replace(/\[/g, '(')
      .replace(/]/g, ')')
    ExcelPrettyUrl = decodeURIComponent(ExcelPrettyUrl)
      .replace(/\[/g, '(')
      .replace(/]/g, ')')
    if (state.excelExport && (state.excelExport.include || state.excelExport.select)) {
      ExcelUrl = ExcelPrettyUrl
    }
    commit('EXCEL_DOWN', ExcelUrl)
    commit('EXCEL_DOWN_PRETTY', ExcelPrettyUrl)
    try {
      const { data } = await client.get(url, newConfig)
      if (data) {
        // -- normalize data
        const transformedData = noTransform ? data.data : normalizeApiData(data, getters.columns, state.fakeColumns)
        const newPagination = {
          sortBy,
          descending,
          page,
          rowsPerPage,
          rowsNumber: data.total || 25
        }
        commit('SET_PAGINATION', newPagination)
        commit('FETCH_ALL', transformedData)
        return {
          ...newPagination,
          ...{ data: transformedData }
        }
      }
      commit('FETCH_ALL', [])
      return []
    } catch (e) {
      handleError(e, this)
    }
  },
  async fetchAll ({ commit, dispatch, state, getters }, { client, fetchRelated = true, parentId = null, config = {}, noFilters = false, shouldCommit = true }) {
    const stateParams = {
      params: state.params
    }
    const stateFilters = {
      params: {
        filter: getters.filterColumns
      }
    }
    let configCombined = extend(true, {}, globalConfig, stateParams, stateFilters, config)
    if (noFilters) {
      if (configCombined && configCombined.params && configCombined.params.filter) {
        delete configCombined.params.filter
      }
      if (configCombined && configCombined.params && configCombined.params.limit) {
        delete configCombined.params.limit
      }
      if (configCombined && configCombined.params && configCombined.params.sort) {
        delete configCombined.params.sort
      }
      if (config) {
        configCombined = extend(true, {}, configCombined, config)
      }
    }
    let newConfig = await dispatch('transformFilters', config)
    if (newConfig.params.include) {
      newConfig.params.$expand = oDataHelper(newConfig.params.include)
      delete newConfig.params.include
    }
    let url = getters.apiEndpoint(parentId)
    url = url.replace('/api/', '/api/odata/')
    url = `${url}/paginate`
    // commit('EXCEL_DOWN', url)
    /* Queue -- Method to reduce duplicate requests */
    try {
      const { data } = await client.get(url, newConfig)
      if (data && data.data) {
        // -- normalize data
        const transformedData = normalizeApiData(data, getters.columns, state.fakeColumns)
        delete data.data
        data.data = transformedData
        if (shouldCommit) {
          commit('FETCH_ALL', data.data)
        }
        return data
      }
    } catch (e) {
      handleError(e, this)
    }
  },
  async apiExcel ({ commit, dispatch, state, getters }, { client, fetchRelated = true, parentId = null, config = {}, noFilters = false }) {
    const stateParams = {
      params: state.params
    }
    const stateFilters = {
      params: {
        filter: getters.filterColumns
      }
    }
    const configCombined = extend(true, {}, globalConfig, stateParams, stateFilters, config)
    try {
      let newConfig = {}
      if (!noFilters) {
        newConfig = await dispatch('transformFilters', configCombined)
      }
      newConfig.responseType = 'arraybuffer'
      // // // console.log(newConfig)
      return await client.get(`/excel${getters.apiEndpoint(parentId)}`, newConfig)
    } catch (e) {
      // // // console.log(e)
      return Promise.reject(e)
    }
  },
  async apiUpdate ({ commit, dispatch, state, getters }, { id, model, client, config = {}, fetchRelated = true, parentId = null, returnAll = false }) {
    const stateParams = {
      params: state.params
    }
    const configCombined = extend(true, {}, globalConfig, stateParams, config)
    try {
      const newConfig = await dispatch('transformFilters', configCombined)
      // console.log('model 1', model)
      if (model && model['guidId'] !== undefined) {
        delete model.guidId
      }
      // console.log('model 2', model)
      // console.log('newConfig', newConfig)
      // console.log('dispatch(\'transformFilters\', newConfig)', dispatch('transformFilters', newConfig))
      // const { data } = await client.put(`${getters.apiEndpoint(parentId)}/${id}`, model, dispatch('transformFilters', newConfig))
      const { data } = await client.put(`${getters.apiEndpoint(parentId)}/${id}`, model, newConfig)
      commit('API_UPDATE', { id: id, updates: data })
      if (returnAll) {
        return await dispatch('fetchAll', { client, parentId, config, fetchRelated, returnAll })
      }
      return data
    } catch (e) {
      // // // console.log(e)
    }
  },
  async excel ({ commit, dispatch, state, getters }, { client, fetchRelated = true, parentId = null, config = {}, noFilters = false, shouldCommit = true }) {
    // // console.log('excel')
    const stateParams = {
      params: state.params
    }
    const stateFilters = {
      params: {
        filter: getters.filterColumns
      }
    }
    let configCombined = extend(true, {}, globalConfig, stateParams, stateFilters, config)
    if (noFilters) {
      if (configCombined && configCombined.params && configCombined.params.filter) {
        delete configCombined.params.filter
      }
      if (configCombined && configCombined.params && configCombined.params.limit) {
        delete configCombined.params.limit
      }
      if (configCombined && configCombined.params && configCombined.params.sort) {
        delete configCombined.params.sort
      }
      if (config) {
        configCombined = extend(true, {}, configCombined, config)
      }
    }
    let newConfig = await dispatch('transformFilters', config)
    if (newConfig.params.include) {
      newConfig.params.$expand = oDataHelper(newConfig.params.include)
      delete newConfig.params.include
    }
    let url = getters.apiEndpoint(parentId)
    url = url.replace('/api/', '/api/odata/')
    url = `${url}/excel`
    return url
  }
}

export default actions => {
  return extend(true, {}, defaultActions, actions)
}
